import axios from "axios";
import { Component } from "react";
import GeneralBloc from "../bloc/general_bloc";
import BaseWebService from "./base_web_service";
import DOMPurify from "dompurify";

export default class FaqWebServices extends Component {
    static async getFaqData(code, payload) {
        let header = await BaseWebService.normalHeaders();
        let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/record/read/template?code=${code}`);
        let resp = await axios.get(
            url,
            {
                headers: header,
                params: payload
            }
        );
        let response = BaseWebService.standardResponseFromWeb(resp.data);
        return response;
    }
}